module.exports = __webpack_public_path__ + "dimer/static/img/12.184451b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/12.jpg
// module id = +ccq
// module chunks = 0